{
  "activeDevicesInView": "Dispositivos activos a la vista",
  "deviceProfileLinkText": "Administrar",
  "controlPanelLinkText": "Controles",
  "automationDescription": {
    "notifyFalse": "Cuando el sensor {{sourceSensor}} de {{sourceDeviceName}} cambia de {{sourceSensorStatePrevious}} a {{sourceSensorStateCurrent}}, {{targetDeviceName}} debería {{namedDeviceAction}}.",
    "notifyTrue": "Cuando el sensor {{sourceSensor}} de {{sourceDeviceName}} cambia de {{sourceSensorStatePrevious}} a {{sourceSensorStateCurrent}}, {{targetDeviceName}} debe {{namedDeviceAction}} y enviar una notificación por SMS."
  },
  "currentStatus": "Estado actual",
  "deviceActivity": {
    "currentStatus": "Estado actual",
    "linkTo": "Actividad",
    "recentActivity": "Actividad reciente",
    "title": "Actividad del dispositivo"
  },
  "deviceInFieldWithFieldName": "En el campo {{fieldName}}",
  "deviceLocationUnknown": "Ubicación del dispositivo desconocida",
  "deviceOffline": "Dispositivo fuera de línea",
  "deviceUnreachable": "Dispositivo inalcanzable",
  "deviceUnreachableDescription": "No se pudo contactar este dispositivo después de varios intentos. Los comandos están pausados hasta {{date}}.",
  "clearUnreachable": "Borrar y reintentar",
  "deviceErrorTimedOut": "El dispositivo tardó demasiado en responder.",
  "deviceErrorUnreachable": "No se pudo contactar el dispositivo.",
  "deviceErrorDidNotRespond": "El dispositivo no respondió.",
  "deviceErrorReturnedFailure": "El dispositivo no pudo completar la solicitud.",
  "deviceProfile": "Perfil del dispositivo",
  "deviceRosterHelpContentBodyText": "En esta lista se muestran todos los dispositivos que pertenecen a su granja.\n\nHaga clic o toque un dispositivo para ver su perfil, donde puede ver y editar los valores de configuración del dispositivo, ver análisis del dispositivo y más.",
  "deviceRosterHelpContentTitle": "Lista de dispositivos",
  "deviceRosterListEmpty": "Su cuenta de granja no tiene dispositivos",
  "deviceRosterSortMenuTitle": "Ordenar dispositivos por",
  "deviceRosterTitle": "Dispositivos",
  "deviceRosterTitleWithItemCount": "Dispositivos ({{itemCount}})",
  "deviceSortKeys": {
    "alphabetical": "Nombre del dispositivo",
    "device_activity": "Actividad",
    "device_installation_type": "Tipo de instalación"
  },
  "eventsUpdated": "Eventos actualizados",
  "forceUpdate": "Actualizar datos",
  "goToFieldProfile": "Ir al perfil del campo",
  "inFieldWithColon": "En el campo:",
  "locationWithColon": "Ubicación:",
  "manageDeviceLinkText": "Administrar",
  "openLocationNavigation": "Abrir opciones de navegación",
  "noActiveDevicesInView": "No hay dispositivos activos a la vista",
  "noCommandsFoundForDevice": "No se encontraron comandos para este dispositivo",
  "noConnections": "No se crearon conexiones para este dispositivo",
  "noEvents": "No se ha detectado actividad en los dispositivos de su granja. Vuelva a consultar más tarde para ver nuevas actualizaciones.",
  "noGps": "Sin GPS",
  "over24HoursAgo": "Hace más de 24 horas",
  "pivotLegendArm": "Brazo del pivote (posición actual)",
  "pivotLegendEndGun": "Cañón final encendido",
  "pivotLegendLastKnown": "Última posición conocida (desactualizada)",
  "pivotLegendSweptArea": "Área recorrida en esta pasada",
  "pivotLegendTitle": "Leyenda del mapa",
  "pivotLegendWater": "Agua activada (mojado)",
  "pivotNextStopWithVal": "Próxima: {{val}}",
  "pivotStale": "Desactualizado",
  "pivotTimeToStopWithVal": "{{val}} para parar",
  "recentActivity": "Actividad reciente",
  "reelSpeed": {
    "max": {
      "defaultValueHint": "Un buen lugar para establecer la velocidad máxima es 10 veces la velocidad de retracción típica.",
      "description": "Si la velocidad del carrete supera la velocidad máxima, consideraremos que el carrete se está extendiendo."
    },
    "min": {
      "defaultValueHint": "Un buen lugar para establecer la velocidad mínima es 1/3 de la velocidad de retracción típica.",
      "description": "Si la velocidad del carrete cae por debajo de la velocidad mínima, consideraremos que el carrete está detenido y tomaremos las acciones que haya configurado."
    }
  },
  "requestUpdateButton": "Solicitar actualización",
  "runComplete": "Ejecutar completo",
  "runEtaWithTimestamp": "ETA: {{val, datetime}}",
  "runProgressFractionWithUnitLabel": "{{distanceElapsed}}/{{distanceMax}} {{unitLabel}}",
  "runStopped": "Interrumpido",
  "runStoppedShort": "Detenido en seco",
  "sensorStateUnknownWithSensorName": "{{sensorName}} Desconocido",
  "sensorStateWithSensorReading": "{{sensorState}} ({{sensorReading}})",
  "sensorStateWithSensorReadingAndUnitLabel": "{{sensorState}} ({{sensorReading}} {{unitLabel}})",
  "setCenterPivotPathCenterMarkerLabel": "Centro",
  "setCenterPivotPathLinkTo": "Establecer esquema",
  "setCenterPivotPathNotSetWarning": "No se ha configurado el contorno del pivote central. Establezca un contorno para habilitar las funciones de seguimiento del pivote central.",
  "setCenterPivotPathSetCenterInstructions": "Toque el mapa para establecer la ubicación del pivote central",
  "setCenterPivotPathTitle": "Establecer el contorno del pivote central",
  "setPidSetpointFormAdvancedLabel": "Configuración PID (Avanzado)",
  "setPidSetpointFormDisclaimerAcknowledgement": "Reconozco que soy responsable de la seguridad del equipo y del personal al configurar la velocidad de seguimiento del VFD.",
  "setPidSetpointFormDisclaimerBody": "Esta es una función experimental. Esta función intentará alcanzar y mantener la presión objetivo lo más rápido posible modificando automáticamente la configuración de velocidad del VFD.",
  "setPidSetpointFormSetPointInputLabel": "Punto de ajuste",
  "setPressurePidSetpointFormTitle": "Mantener la presión",
  "setVfdSpeedFormFrequencyLabel": "Velocidad (porcentaje)",
  "setVfdSpeedFormImmediateLabel": "Inmediato",
  "setVfdSpeedFormInstructions": "Especifique el porcentaje deseado y el tiempo de rampa.",
  "setVfdSpeedFormMinutesInputLabel": "Minutos",
  "setVfdSpeedFormRamp": "Rampa",
  "setVfdSpeedFormRampLabel": "Rampa",
  "setVfdSpeedFormRampTimeInstructions": "Tiempo de rampa",
  "setVfdSpeedFormSecondsInputLabel": "Artículos de segunda clase",
  "setVfdSpeedFormTitle": "Establecer la velocidad del VFD",
  "showAllDevices": "Mostrar todos los dispositivos",
  "title": "Estado del dispositivo",
  "updateRequested": "Actualización solicitada desde el dispositivo...",
  "vfd": {
    "off": "VFD apagado",
    "on": "VFD activado",
    "over": "VFD terminado",
    "ramping": "Aumento de la frecuencia variable (VFD)",
    "title": "Variador de frecuencia variable",
    "trackingWithValue": "Seguimiento de {{value}} {{unit}}",
    "under": "VFD bajo"
  },
  "waitingForUpdate": "Esperando actualización...",
  "deviceAlias": "Alias del dispositivo"
}
